import React from "react";
import {HrWrapper} from "@/components/hr/style";

function Hr({style}) {
    return (
        <HrWrapper style={style}/>
    );
}

export default Hr